import React from 'react'
import { Announcement } from '../../models/Announcement'

type Props = {
    announcement: Announcement;
}

const AnnouncementPiece = ({ announcement }: Props) => {
    return (
        <div
            className="bg-white p-2"
        >
            <div className="text-primary-dark text-[18px] font-bold">
                {announcement.title}
            </div>
            <div
                className="text-primary-dark text-[14px] font-normal"
                dangerouslySetInnerHTML={{ __html: announcement.body }}
            />
        </div>
    )
}

export default AnnouncementPiece